/* Peintio site scripts - built 18 sep 2026 from the peintio-* snippets; 20 sep: the two blocks that styled the old app cart (peintio-cart-savings, peintio-cart-offer) removed - the theme drawer (snippets/cart-drawer.liquid + assets/peintio-cart.js) renders the ladder, ship pill and savings itself; 26 sep (speed v2): the last hooks for that app removed (favoriter hearts on its widget, login line events) and the search keyword redirects (snippets/peintio-search-redirects.liquid, 22 sep) folded in as the last block. Every block is self-contained and DOM-robust (polls/observers) and wrapped in try/catch so one block can never stop the next. window.peintioLogin is set inline by snippets/peintio-login.liquid. EDIT THIS FILE, not the old snippets. */

/* ===== peintio-hero-swap (from snippets/peintio-hero-swap.liquid) ===== */
try {
(function () {
  var K = 'slide' + 'show';
  var t0 = new Date().getTime();
  var timer = null;
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function tick() {
    var car = document.querySelector('.' + K + '[data-section-index]');
    var stat = document.querySelector('.' + K + '-static-first');
    if (car && stat && car.getAttribute('data-initiated') === 'true') {
      car.style.opacity = '1';
      car.style.visibility = 'visible';
      stat.style.display = 'none';
      stop();
      return;
    }
    if (new Date().getTime() - t0 > 15000) stop();
  }
  timer = setInterval(tick, 100);
  tick();
  document.addEventListener('DOMContentLoaded', tick);
  window.addEventListener('load', tick);
})();
} catch (e) { if (window.console) console.warn("peintio-hero-swap", e); }

/* ===== peintio-ui-batch (from snippets/peintio-ui-batch.liquid) ===== */
try {
(function(){
  function wrap(root){
    var imgs = (root || document).querySelectorAll('.mobile-social-icons a > img');
    for (var i = 0; i < imgs.length; i++){
      var img = imgs[i];
      if (img.parentElement && img.parentElement.classList.contains('peintio-soc-disc')) continue;
      var s = document.createElement('span');
      s.className = 'peintio-soc-disc';
      img.parentElement.insertBefore(s, img);
      s.appendChild(img);
    }
  }
  wrap();
  document.addEventListener('DOMContentLoaded', function(){ wrap(); });
  /* the drawer is populated/revealed on open, so watch for it rather than run once */
  var mo = new MutationObserver(function(){ wrap(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', function(){ setTimeout(wrap, 120); }, true);
  setTimeout(function(){ mo.disconnect(); }, 30000);
})();
} catch (e) { if (window.console) console.warn("peintio-ui-batch", e); }

/* ===== peintio-footer-signup (from snippets/peintio-footer-signup.liquid) ===== */
try {
(function(){
  var textDone = false, socDone = false;
  function fix(){
    var foot = document.querySelector('.peintio-footer');
    if (!foot) return;

    if (!textDone){
      var titles = foot.querySelectorAll('.footer-column-title');
      for (var i = 0; i < titles.length; i++){
        if (/JOIN OUR COMMUNITY/i.test(titles[i].textContent)){
          titles[i].textContent = 'BLI EN AV OSS';
          textDone = true;
        }
      }
      var p = foot.querySelector('.newsletter-text');
      if (p && /signar upp/i.test(p.textContent)){
        p.textContent = 'Få 20% rabatt på ditt första köp när du anmäler dig till vårt nyhetsbrev!';
      }
    }

    if (!socDone){
      var imgs = foot.querySelectorAll('.footer-social-menu a > img');
      if (imgs.length){
        for (var j = 0; j < imgs.length; j++){
          var img = imgs[j];
          if (img.parentElement && img.parentElement.classList.contains('peintio-soc-disc')) continue;
          var span = document.createElement('span');
          span.className = 'peintio-soc-disc';
          img.parentElement.insertBefore(span, img);
          span.appendChild(img);
        }
        socDone = true;
      }
    }
  }
  fix();
  document.addEventListener('DOMContentLoaded', fix);
  var n = 0, t = setInterval(function(){
    fix();
    if ((textDone && socDone) || ++n > 40) clearInterval(t);
  }, 250);
})();
} catch (e) { if (window.console) console.warn("peintio-footer-signup", e); }

/* ===== peintio-banner (from snippets/peintio-banner.liquid) ===== */
try {
/* -- (7) PDP CTA text: keep client-side repaints on "Lägg i varukorgen" (see comment above) -- */
(function(){
  function peintioFixAtcString(){
    if (window.theme && window.theme.variantStrings) {
      window.theme.variantStrings.addToCart = 'Lägg i varukorgen';
    }
  }
  peintioFixAtcString();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', peintioFixAtcString);
  }
})();
} catch (e) { if (window.console) console.warn("peintio-banner", e); }

/* ===== peintio-mobile-fixes (from snippets/peintio-mobile-fixes.liquid) ===== */
try {
(function(){
  /* v8 / TODO 69: shipping note right under the price, every width */
  function shippingNote(){
    var price = document.querySelector('.product-price-container > .no-js-hidden');
    if (!price || document.querySelector('.peintio-shipping-note')) return;
    var n = document.createElement('div');
    n.className = 'peintio-shipping-note';
    n.innerHTML = '<strong>Fri frakt</strong> vid 2 posters eller fler';
    price.insertAdjacentElement('afterend', n);
  }
  /* v7: sticky add-to-cart bar also while the form is still BELOW the fold (mobile only).
     The theme's own observer only shows it after the form has been scrolled past.
     Rect-based on purpose: IntersectionObserver does not fire in background tabs. */
  function stickyBelowFold(){
    if (window.innerWidth > 767) return;
    var sticky = document.querySelector('product-add-to-cart-sticky');
    if (!sticky) return;
    var form = document.getElementById('product-form-' + sticky.dataset.section);
    if (!form) return;
    var below = false, ticking = false;
    function check(){
      ticking = false;
      var r = form.getBoundingClientRect();
      if (r.top > window.innerHeight) {
        if (!below) { below = true; sticky.classList.add('sticky--visible'); }
      } else if (below && r.bottom > 0) {
        below = false; sticky.classList.remove('sticky--visible');
      }
    }
    function queue(){ if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', check);
    document.addEventListener('visibilitychange', check);
    check(); setTimeout(check, 1500);
  }
  function init(){ shippingNote(); stickyBelowFold(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
} catch (e) { if (window.console) console.warn("peintio-mobile-fixes", e); }

/* ===== peintio-login (from snippets/peintio-login.liquid) ===== */
try {
(function(){
  var LOGGED_IN = !!(window.peintioLogin && window.peintioLogin.loggedIn);
  var HREF = (window.peintioLogin && window.peintioLogin.href) || '/account/login';
  var LABEL = LOGGED_IN ? 'Mitt konto' : 'Logga in';

  /* 1 + 2: header icon href, mobile-menu link, footer link */
  function links(){
    var icon = document.querySelector('a.thb-secondary-myaccount');
    if(icon && icon.getAttribute('href') !== HREF){
      icon.setAttribute('href', HREF);
      icon.setAttribute('title', LABEL);
    }
    var lists = [
      document.querySelector('.mobile-info-links ul'),
      document.querySelector('.footer-column .footer-menu')
    ];
    for(var i = 0; i < lists.length; i++){
      var ul = lists[i];
      if(!ul || ul.querySelector('.peintio-login-link')) continue;
      var li = document.createElement('li');
      li.className = 'peintio-login-link';
      var a = document.createElement('a');
      a.href = HREF;
      a.title = LABEL;
      a.textContent = LABEL;
      var ref = ul.firstElementChild;
      if(ref && ref.firstElementChild && ref.firstElementChild.getAttribute('style')){
        li.setAttribute('style', ref.getAttribute('style') || '');
        a.setAttribute('style', ref.firstElementChild.getAttribute('style') || '');
      }
      li.appendChild(a);
      ul.insertBefore(li, ref);
    }
  }
  function linksTick(){ try{ links(); }catch(e){} }
  linksTick();
  document.addEventListener('DOMContentLoaded', linksTick);
  setTimeout(linksTick, 1500);
  setTimeout(linksTick, 4000);
  document.addEventListener('click', function(){ setTimeout(linksTick, 200); }, true);

  /* 3: the cart drawer line - only when cart sync is real (or previewed) */
  var ENABLED = !!(window.peintioLogin && window.peintioLogin.cartSync) || /(^|[?&])peintio_login=1/.test(window.location.search);
  if(!ENABLED) return;
  var queued = false;

  function anchor(){
    var ship = document.getElementById('peintio-ship-wrap');
    if(ship && ship.parentNode) return { node: ship, inBar: ship.className === 'in-bar' };
    return null;
  }

  function paint(){
    var a = anchor();
    var wrap = document.getElementById('peintio-login-wrap');
    if(!a){
      if(wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
      return;
    }
    if(!wrap){
      wrap = document.createElement('div');
      wrap.id = 'peintio-login-wrap';
      var el = document.createElement('div');
      el.id = 'peintio-login';
      if(LOGGED_IN){
        el.className = 'is-in';
        el.textContent = '✓ Inloggad – din varukorg följer med till dina andra enheter';
      } else {
        var link = document.createElement('a');
        link.href = HREF;
        link.textContent = 'Logga in';
        el.appendChild(link);
        el.appendChild(document.createTextNode(' så följer varukorgen med till dina andra enheter'));
      }
      wrap.appendChild(el);
    }
    if(a.node.nextSibling !== wrap || wrap.parentNode !== a.node.parentNode){
      a.node.parentNode.insertBefore(wrap, a.node.nextSibling);
    }
    var cls = a.inBar ? 'in-bar' : '';
    if(wrap.className !== cls) wrap.className = cls;
  }

  function tick(){
    if(queued) return;
    queued = true;
    setTimeout(function(){ queued = false; try{ paint(); }catch(e){} }, 150);
  }

  try{
    if(window.MutationObserver){
      new MutationObserver(tick).observe(document.documentElement, { childList: true, subtree: true });
    }
  }catch(e){}
  setInterval(tick, 1500);
  tick();
})();
} catch (e) { if (window.console) console.warn("peintio-login", e); }

/* ===== peintio-favoriter (from snippets/peintio-favoriter.liquid) ===== */
try {
(function(){
  var KEY = 'peintio_favs';
  var PAGE = '/pages/favoriter';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.4-9.2C1.2 8 3.2 4.5 6.8 4.5c2 0 3.6 1.1 5.2 3 1.6-1.9 3.2-3 5.2-3 3.6 0 5.6 3.5 4.2 6.8-1.9 4.6-9.4 9.2-9.4 9.2z"/></svg>';
  var KLAVIYO = { fav_add: 'Favoritmarkerad', fav_remove: 'Favorit borttagen', fav_page_view: 'Favoriter visade', fav_atc: 'Favorit lagd i varukorg' };

  /* ---------- storage ---------- */
  function read(){
    try{ var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }catch(e){ return []; }
  }
  function write(list){ try{ localStorage.setItem(KEY, JSON.stringify(list)); }catch(e){} }
  function has(h){ var l = read(); for(var i = 0; i < l.length; i++){ if(l[i].h === h) return true; } return false; }
  function add(item){
    if(!item || !item.h) return read();
    var l = read();
    for(var i = 0; i < l.length; i++){ if(l[i].h === item.h) return l; }
    l.unshift({ h: item.h, t: item.t || '', img: item.img || '', at: new Date().getTime() });
    write(l);
    track('fav_add', { handle: item.h, title: item.t || '', count: l.length });
    changed();
    return l;
  }
  function remove(h){
    var l = read().filter(function(x){ return x.h !== h; });
    write(l);
    track('fav_remove', { handle: h, count: l.length });
    changed();
    return l;
  }
  function toggle(item){ if(has(item.h)){ remove(item.h); return false; } add(item); return true; }

  /* ---------- measurement ---------- */
  function track(name, data){
    data = data || {};
    try{ if(typeof window.clarity === 'function'){ window.clarity('event', name); window.clarity('set', 'favoriter', String(read().length)); } }catch(e){}
    try{
      window.dataLayer = window.dataLayer || [];
      var dl = { event: 'peintio_' + name };
      for(var k in data){ if(data.hasOwnProperty(k)) dl[k] = data[k]; }
      window.dataLayer.push(dl);
      if(name === 'fav_add' && typeof window.gtag === 'function'){
        window.gtag('event', 'add_to_wishlist', { currency: 'SEK', value: data.price || 0, items: [{ item_id: data.handle, item_name: data.title || data.handle }] });
      }
    }catch(e){}
    try{
      var kl = window.klaviyo || window._learnq;
      if(kl && typeof kl.push === 'function' && KLAVIYO[name]){
        var props = { Handle: data.handle || '', Titel: data.title || '', Antal_favoriter: data.count != null ? data.count : read().length };
        if(data.handle) props.URL = window.location.origin + '/products/' + data.handle;
        if(data.n != null) props.Antal_tillagda = data.n;
        kl.push(['track', KLAVIYO[name], props]);
      }
    }catch(e){}
  }

  /* ---------- toast ---------- */
  var toastTimer = null;
  function toast(html){
    var t = document.getElementById('peintio-fav-toast');
    if(!t){ t = document.createElement('div'); t.id = 'peintio-fav-toast'; document.body.appendChild(t); }
    t.innerHTML = html;
    t.classList.add('is-visible');
    if(toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- hearts ---------- */
  function makeHeart(data, ctx){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'peintio-fav peintio-fav--' + ctx + (has(data.h) ? ' is-on' : '');
    b.setAttribute('data-handle', data.h);
    b.setAttribute('aria-label', has(data.h) ? 'Sparad som favorit – tryck för att ta bort' : 'Spara som favorit');
    b.innerHTML = HEART;
    b.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var on = toggle(data);
      if(on){
        b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
        toast('Sparad i dina favoriter <a href="' + PAGE + '">Visa</a>');
      }
    }, true);
    return b;
  }

  function cardData(card){
    var link = card.querySelector('a.product-featured-image-link') || card.querySelector('a[href*="/products/"]');
    if(!link) return null;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    if(!m) return null;
    var t = card.querySelector('.product-card-title');
    var img = card.querySelector('img.product-primary-image') || card.querySelector('img');
    var src = '';
    if(img){ src = img.currentSrc || img.src || img.getAttribute('data-src') || ''; }
    if(src.indexOf('data:') === 0) src = img.getAttribute('data-src') || '';
    return { h: m[1], t: t ? t.textContent.replace(/\s+/g, ' ').trim() : (link.getAttribute('title') || ''), img: src };
  }

  function decorateCards(){
    var cards = document.querySelectorAll('product-card.product-card, .product-card');
    for(var i = 0; i < cards.length; i++){
      var fig = cards[i].querySelector('figure.product-featured-image');
      if(!fig || fig.querySelector('.peintio-fav')) continue;
      var d = cardData(cards[i]);
      if(!d) continue;
      fig.appendChild(makeHeart(d, 'card'));
    }
  }

  function pdpData(){
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if(!m) return null;
    var h1 = document.querySelector('h1.product-title');
    var img = document.querySelector('.product-gallery-container .product-images__slide.is-active img') || document.querySelector('.product-gallery-container .product-images__slide img');
    var src = img ? (img.currentSrc || img.src || '') : '';
    return { h: m[1], t: h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '', img: src };
  }

  function decoratePdp(){
    var d = pdpData();
    if(!d) return;
    var boxes = document.querySelectorAll('.product-gallery-container .product-images__slide .product-single__media-image');
    for(var i = 0; i < boxes.length; i++){
      if(boxes[i].querySelector('.peintio-fav')) continue;
      boxes[i].appendChild(makeHeart(d, 'pdp'));
    }
    var gal = document.querySelector('.product-gallery-container');
    if(gal){
      var noSel = !gal.querySelector('.product-images__slide.is-selected');
      if(gal.classList.contains('peintio-no-select') !== noSel) gal.classList.toggle('peintio-no-select', noSel);
    }
  }

  function decorateHeader(){
    var area = document.querySelector('.thb-secondary-area');
    if(!area || area.querySelector('.peintio-fav-link')) return;
    var a = document.createElement('a');
    a.className = 'thb-secondary-area-item peintio-fav-link';
    a.href = PAGE;
    a.title = 'Favoriter';
    a.setAttribute('aria-label', 'Favoriter');
    a.innerHTML = '<span class="peintio-fav-ico">' + HEART + '<span class="peintio-fav-count"></span></span>';
    var first = area.querySelector('.thb-secondary-myaccount') || area.firstElementChild;
    area.insertBefore(a, first);
  }

  function paint(){
    var l = read();
    var n = l.length;
    var map = {};
    for(var i = 0; i < n; i++) map[l[i].h] = true;
    var hearts = document.querySelectorAll('.peintio-fav');
    for(var j = 0; j < hearts.length; j++){
      var on = !!map[hearts[j].getAttribute('data-handle')];
      if(hearts[j].classList.contains('is-on') !== on){
        hearts[j].classList.toggle('is-on', on);
        hearts[j].setAttribute('aria-label', on ? 'Sparad som favorit – tryck för att ta bort' : 'Spara som favorit');
      }
    }
    var links = document.querySelectorAll('.peintio-fav-link');
    for(var k = 0; k < links.length; k++){
      links[k].classList.toggle('has-favs', n > 0);
      var c = links[k].querySelector('.peintio-fav-count');
      if(c && c.textContent !== String(n)) c.textContent = String(n);
    }
  }

  function changed(){
    paint();
    try{ document.dispatchEvent(new CustomEvent('peintio:favs', { detail: { count: read().length } })); }catch(e){}
  }

  var queued = false;
  function tick(){
    if(queued) return;
    queued = true;
    setTimeout(function(){
      queued = false;
      try{ decorateHeader(); decorateCards(); decoratePdp(); paint(); }catch(e){}
    }, 150);
  }

  function init(){
    tick();
    try{
      if(window.MutationObserver){
        new MutationObserver(tick).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }
    }catch(e){}
    window.addEventListener('storage', function(e){ if(e.key === KEY) changed(); });
    window.addEventListener('resize', tick);
    window.addEventListener('load', function(){ setTimeout(tick, 800); });
    setTimeout(tick, 1500);
    setTimeout(tick, 4000);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.PeintioFav = { read: read, add: add, remove: remove, has: has, toggle: toggle, track: track, makeHeart: makeHeart, toast: toast, KEY: KEY, PAGE: PAGE };
})();
} catch (e) { if (window.console) console.warn("peintio-favoriter", e); }

/* ===== peintio-search-redirects (from snippets/peintio-search-redirects.liquid, 22 sep): search keyword -> collection, ported from the old search app. Match: the whole term equals a keyword, or (keyword >= 4 letters) the term starts with it. ===== */
try {
(function () {
  var MAP = [
    ['sommar', 'summer', 'sommriga'], '/collections/sommriga-motiv',
    ['drink', 'drinks', 'drinkar', 'dri', 'vin'], '/collections/drinks',
    ['tulpan', 'tulpa', 'tul', 'tulp', 'tulpaner'], '/collections/flowers',
    ['liggande', 'ligga', 'horisontell', 'horizontal', 'horisontel', 'hori', 'ligg', 'liggand'], '/collections/horisontell-liggande',
    ['william', 'morri', 'william morris', 'wiliam', 'moris', 'wiliam moris', 'vincent', 'van gogh', 'vincent van gogh', 'gogh'], '/collections/kanda-konstnarer',
    ['bauhaus', 'bau'], '/collections/bauhaus',
    ['jul', 'christmas'], '/collections/christmas',
    ['vinter', 'winter', 'snö', 'snow'], '/collections/vinter',
    ['kök', 'kitchen'], '/collections/kitchen',
    ['barn', 'kids'], '/collections/kids',
    ['djur', 'hund', 'animals'], '/collections/animals',
    ['food', 'dinner', 'mat', 'middag'], '/collections/dinner'
  ];
  function target(q) {
    q = String(q || '').toLowerCase().replace(/\s+/g, ' ').trim();
    if (!q) { return null; }
    var best = null, bestLen = 0;
    for (var i = 0; i < MAP.length; i += 2) {
      var words = MAP[i], url = MAP[i + 1];
      for (var j = 0; j < words.length; j++) {
        var w = words[j];
        var hit = q === w || (w.length >= 4 && q.indexOf(w) === 0);
        if (hit && w.length > bestLen) { best = url; bestLen = w.length; }
      }
    }
    return best;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[role="search"]')) { return; }
    var input = form.querySelector('input[name="q"]');
    var url = input && target(input.value);
    if (url) { e.preventDefault(); window.location.href = url; }
  }, true);
  if (window.location.pathname.replace(/\/$/, '') === '/search') {
    var m = window.location.search.match(/[?&]q=([^&]*)/);
    var url = m && target(decodeURIComponent(m[1].replace(/\+/g, ' ')));
    if (url) { window.location.replace(url); }
  }
})();
} catch (e) { if (window.console) console.warn("peintio-search-redirects", e); }
